import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = { class: "text-muted-darker fw-bold me-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://valored.it",
    class: "text-success"
  }, "VALORE D")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "C.F. 97521290151", -1)
const _hoisted_6 = { class: "mx-2" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "mx-2" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "mx-2" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "menu menu-gray-600 menu-hover-primary fw-bold order-1" }
const _hoisted_13 = { class: "menu-item" }
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid':  _ctx.footerWidthFluid,
        'container-xxl'  : !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, "© Copyright " + _toDisplayString(_ctx.currentYear) + " - ", 1),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("a", {
            href: "#",
            class: "text-success",
            role: "link",
            "aria-haspopup": "dialog",
            "aria-controls": "openPrivacyPolicy",
            "aria-label": _ctx.translate('PRIVACY_POLICY_LABEL'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)))
          }, _toDisplayString(_ctx.translate("PRIVACY_POLICY_LABEL")), 9, _hoisted_7)
        ]),
        _createElementVNode("span", _hoisted_8, [
          _createElementVNode("a", {
            href: "#",
            class: "text-success",
            role: "link",
            "aria-haspopup": "dialog",
            "aria-controls": "openCookiePolicy",
            "aria-label": _ctx.translate('COOKIE_POLICY_LABEL'),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCookiePolicy && _ctx.openCookiePolicy(...args)))
          }, _toDisplayString(_ctx.translate("COOKIE_POLICY_LABEL")), 9, _hoisted_9)
        ]),
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("a", {
            href: "#",
            class: "iubenda-cs-preferences-link text-success",
            role: "link",
            "aria-haspopup": "dialog",
            "aria-controls": "openCookiePreferences",
            "aria-label": _ctx.translate('PREFERENCE_COOKIE_LABEL'),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCookiePreferences && _ctx.openCookiePreferences(...args)))
          }, _toDisplayString(_ctx.translate("PREFERENCE_COOKIE_LABEL")), 9, _hoisted_11)
        ])
      ]),
      _createElementVNode("ul", _hoisted_12, [
        _createElementVNode("li", _hoisted_13, [
          (_ctx.locale === 'it')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "mailto:inclusionimpactindexplus@valored.it?subject=Assistenza%20piattaforma%20Inclusion%20Impact%20Index%20Plus",
                target: "_blank",
                class: "menu-link px-2 text-success",
                role: "link",
                "aria-haspopup": "dialog",
                "aria-controls": "openCookiePreferences",
                "aria-label": _ctx.translate('CONTACT_US_LABEL')
              }, _toDisplayString(_ctx.translate("CONTACT_US_LABEL")), 9, _hoisted_14))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "mailto:inclusionimpactindexplus@valored.it?subject=Support%20for%20Inclusion%20Impact%20Index%20Plus",
                target: "_blank",
                class: "menu-link px-2 text-success",
                role: "link",
                "aria-haspopup": "dialog",
                "aria-controls": "openCookiePreferences",
                "aria-label": _ctx.translate('CONTACT_US_LABEL')
              }, _toDisplayString(_ctx.translate("CONTACT_US_LABEL")), 9, _hoisted_15))
        ])
      ])
    ], 2)
  ]))
}